module.exports = __webpack_public_path__ + "img/no_coupon_ico.2d4ee9eb.png";